import React from 'react';

interface CookieConsentBannerProps {
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onManage: () => void;
}

const CookieConsentBanner: React.FC<CookieConsentBannerProps> = ({ onAcceptAll, onRejectAll, onManage }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white p-4 shadow-lg z-50 animate-fade-in-up">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center">
        <p className="text-sm mb-4 sm:mb-0 sm:mr-4">
          We use cookies to enhance your experience, analyze site traffic, and for essential functionality. You can accept all cookies, use only the strictly necessary ones, or manage your preferences.
        </p>
        <div className="flex-shrink-0 flex flex-wrap justify-center gap-2">
          <button onClick={onManage} className="px-4 py-2 text-sm font-semibold bg-gray-600 rounded-md hover:bg-gray-500">
            Manage Cookies
          </button>
          <button onClick={onRejectAll} className="px-4 py-2 text-sm font-semibold bg-gray-600 rounded-md hover:bg-gray-500">
            Necessary Only
          </button>
          <button onClick={onAcceptAll} className="px-4 py-2 text-sm font-semibold bg-blue-600 rounded-md hover:bg-blue-700">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
